<template>
  <span class="san-highlight">
    <template
      v-for="(part, partIndex) in parts"
      :key="partIndex"
    >
      <template
        v-for="(subPart, subPartIndex) in part"
        :key="subPartIndex"
      >
        <!-- {{ console.log('%csubPart', 'color:lime', subPart) }}
        {{ console.log('%cTagName', 'color:accent', subPart.isHighlighted ? highlightedTagName : nonHighlightedTagName) }} -->
        <component
          :is="highlightedTagName"
          v-if="subPart.isHighlighted"
          class="san-highlight--highlighted"
        >
          {{ subPart.value }}
        </component>
        <template v-else>
          {{ subPart.value }}
        </template>
      </template>

      <span v-if="partIndex !== parts.length - 1">{{ separator }}</span>
    </template>
  </span>
</template>

<script setup>
import { createHighlightComponent } from 'instantsearch-ui-components'
import { getHighlightedParts, getPropertyByPath, unescape } from 'instantsearch.js/es/lib/utils'
import { createElement, Fragment } from 'vue-instantsearch/src/util/pragma.js'

const Highlight = createHighlightComponent({ createElement, Fragment })

defineOptions({ name: 'SanHighlight' })

const props = defineProps({
  hit: { type: Object, required: true },
  attribute: { type: String, required: true },
  highlightedTagName: { type: String, default: 'mark' },
  suit: { type: Function, required: true },
  highlightProperty: { type: String, required: true },
  preTag: { type: String, required: true },
  postTag: { type: String, required: true }
})

const render = () => { // eslint-disable-line
  const property = getPropertyByPath(this.hit[this.highlightProperty], this.attribute) || []
  const properties = Array.isArray(property) ? property : [property]

  const parts = properties.map(singleValue =>
    getHighlightedParts(unescape(singleValue.value || '')).map(
      ({ value, isHighlighted }) => ({
        // We have to do this because Vue gets rid of TextNodes with a single white space
        value: value === ' ' ? '  ' : value,
        isHighlighted
      })
    )
  )

  return createElement(Highlight, {
    classNames: {
      root: this.suit(),
      highlighted: this.suit('highlighted')
    },
    highlightedTagName: this.highlightedTagName,
    nonHighlightedTagName: Fragment,
    parts
  })
}

</script>
